import { Box, Typography, useTheme } from "@mui/material";
import { Check, Ban } from "lucide-react";

export default function CheckItem({
  text,
  isTrue = true,
}: {
  text: string;
  isTrue?: boolean;
}) {
  const t = useTheme();
  return (
    <Box
      sx={(t) => ({
        display: "flex",
        alignItems: "center",
        gap: t.nawy.spacing.xxs,
      })}
    >
      {isTrue ? (
        <Check size="16px" color={t.nawy.colors.semantic.layer.accent} />
      ) : (
        <Ban size="16px" color={t.nawy.colors.semantic.layer.accent} />
      )}
      <Typography
        sx={(theme) => theme.nawy.typography.english.variants.body.md.regular}
      >
        {text}
      </Typography>
    </Box>
  );
}
